/**
 * @file Represents a button component used to reset filters.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, styled } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const StyledButton = styled(Button)(({ theme }) => ({
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    minWidth: '70px'
}));

/**
 * The `ResetFiltersButton` component renders a button with custom styling
 * intended to allow users to reset filter values.
 * When clicked, the button triggers the `onReset` function passed as a prop.
 *
 * @component
 * @param {Object} props - The component's props.
 * @param {function} props.onReset - Function called when the button is clicked to reset filters.
 * @returns {React.ReactElement} The rendered ResetFiltersButton component.
 */
const ResetFiltersButton = ({ onReset }) => {
    return (
        <StyledButton
            id={'resetFiltersButton'}
            variant='minorContained'
            endIcon={<RefreshIcon sx={{ transform: 'scaleX(-1)' }} />}
            onClick={onReset}
            data-analyticsid='reset-button'
        >
            Reset
        </StyledButton>
    );
};

ResetFiltersButton.propTypes = {
    onReset: PropTypes.func.isRequired
};

export default ResetFiltersButton;
